import { DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Collapse, Form, Input, InputNumber } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { t } from 'i18next';
import type { ReactNode, RefObject } from 'react';

interface InternshipSessionFormComponentProps {
  studyLineNames: RefObject<Array<Array<string>>>;
}

export const InternshipSessionFormComponent = ({
  studyLineNames,
}: InternshipSessionFormComponentProps): ReactNode => {
  return (
    <>
      {studyLineNames.current?.flat(1).map((studyLineName, index) => (
        <Collapse
          key={studyLineName}
          items={[
            {
              key: studyLineName + t('uniForm.slineComp.session'),
              label: `${studyLineName} - ${t('uniForm.sessionComp.label')}`,
              children: (
                <Form.List name={['sessions', index]}>
                  {(fields, fieldOperations) => (
                    <div style={{ display: 'flex' }}>
                      {fields.map((field) => (
                        <Card
                          size="small"
                          type="inner"
                          style={{
                            border: '1px solid gray',
                            margin: '1%',
                          }}
                          key={field.key}
                        >
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t('validator.sessionDescriptionEmpty'),
                              },
                            ]}
                            name={[field.name, 'description']}
                          >
                            <TextArea
                              autoSize
                              placeholder={t('uniForm.sessionComp.description')}
                            />
                          </Form.Item>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t(
                                  'validator.sessionYearsOfStudyEmpty'
                                ),
                              },
                            ]}
                            name={[field.name, 'yearsOfStudy']}
                          >
                            <InputNumber
                              style={{
                                width: '100%',
                              }}
                              placeholder={t(
                                'uniForm.sessionComp.yearsOfStudy'
                              )}
                            />
                          </Form.Item>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t(
                                  'validator.sessionCourseCreditEmpty'
                                ),
                              },
                            ]}
                            name={[field.name, 'courseCredit']}
                          >
                            <Input
                              placeholder={t(
                                'uniForm.sessionComp.courseCredit'
                              )}
                            />
                          </Form.Item>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t('validator.sessionHoursEmpty'),
                              },
                            ]}
                            name={[field.name, 'sessionHours']}
                          >
                            <InputNumber
                              required
                              style={{ width: '100%' }}
                              placeholder={t('uniForm.sessionComp.hours')}
                            />
                          </Form.Item>
                          <DeleteOutlined
                            style={{
                              width: '100%',
                              justifyContent: 'right',
                            }}
                            onClick={() => {
                              fieldOperations.remove(field.name);
                            }}
                          />
                        </Card>
                      ))}
                      <div
                        style={{
                          alignContent: 'center',
                        }}
                      >
                        <Button
                          style={{ margin: '1%' }}
                          type="primary"
                          onClick={() => {
                            fieldOperations.add();
                          }}
                        >
                          {t('uniForm.sessionComp.addSession')}
                        </Button>
                      </div>
                    </div>
                  )}
                </Form.List>
              ),
            },
          ]}
        />
      ))}
    </>
  );
};
